import FirebaseUsage from '../firebase/firebase.usage';
import LocalStorageHelper from '../utils/local-storage.helper';
import SignInBodyModel from "../models/reqest-body-models/sign-in-body.model";
import {UserCredential} from "@firebase/auth-types";

export default class AuthorizationApi {
    public static async sendSignInLinkToEmail(body: string): Promise<void> {
        return FirebaseUsage.sendSignInLinkToEmail(body, {
            url: window.location.origin,
            handleCodeInApp: true,
        }).then(function () {
            LocalStorageHelper.setEmailForSignIn(body);
        }).catch(function (error) {
            console.log(error);
        });
    }

    public static async signInWithEmailLink() {
        const isSignIn = FirebaseUsage.isSignInWithEmailLink(window.location.href);
        const email = LocalStorageHelper.emailForSignIn();
        if(!email || !isSignIn) {
            throw new Error('not Auth');
        }
        return isSignIn
            ? await FirebaseUsage.signInWithEmailLink(email || '', window.location.href)
                .then((result) => {
                    FirebaseUsage.addDocument('login_attempts', {
                        email: result.user?.email || '',
                        timestamp: FirebaseUsage.timestamp(),
                        successful: true,
                        window: window.location.href || '',
                    });
                })
                .catch((e) => {
                    FirebaseUsage.addDocument('login_attempts', {
                        email: email || '',
                        timestamp: FirebaseUsage.timestamp(),
                        successful: false,
                        errorMessage: e.message,
                        window: window.location.href || '',
                    })
                    return null;
                })
            : null
    }

    public static async logOut() {
        return await FirebaseUsage.signOutOfAuth();
    }
}
